// import arr len and sample text to return img src arr
export const getSrcs = (
  len: number,
  sample: string,
  option?: { suffix?: string; start?: number },
) => {
  // let suffix = 'png'
  let suffix = 'webp'
  let start = 1
  if (option) {
    suffix = option.suffix ?? suffix
    start = option.start ?? start
  }
  const strs = sample.split('<R>')
  const arr = Array.from(Array(len).keys()).map(ele => {
    const idx = ele + start
    const str = strs.join(`${idx}`)
    return `${str}.${suffix}`
  })
  return arr
}

export const getHintsSrc = (hintsIdx: string[]) => {
  const entries: string[][] = []
  hintsIdx.forEach(hintIdx => {
    const idx0 = hintIdx.split('-')[0]
    const idx1 = hintIdx.split('-')[1]
    const k =
      'hint' + String.fromCharCode(parseInt(idx0) + 1 + 64) + idx1
    // const entry = [k, `/images/hints/${idx0}-${idx1}.png`]
    const entry = [k, `/images/webp/hints/${idx0}-${idx1}.webp`]
    entries.push(entry)
  })

  return Object.fromEntries(entries)
}

export const getPreloadSrcs = (args: any[]): string[] => {
  const srcs: string[][] = []
  args.forEach(o => {
    const vals = Object.values(o).flat() as string[]
    srcs.push(vals)
  })

  return Array.from(new Set(srcs.flat()))
}
